import React, { useEffect, useState } from 'react'
import { Form, Upload, Button, Row, Col, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import { toast } from 'react-toastify'

const UploadDocument = props => {
  const { form, moduleId, documentId, policynumber, policyId, insurerId, ProductId, onSucess, visible } = props
  const { getFieldDecorator, validateFields } = form
  const [moduleDocument, setModuleDocument] = useState([])

  useEffect(() => {
    if (moduleId) {
      fetchModuleDocument(moduleId)
    }
  }, [visible])

  const fetchModuleDocument = async moduleId => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL_DOCUMENT +
        `/ModuleDocument/ByInsurer/${moduleId}/${ProductId}/${insurerId}`,
      )
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const data = await response.json()

      const modifiedData =
        data?.data?.map(doc => ({
          ...doc,
          key: `document_${doc.documentMasterId}`,
          filePath: doc.filePath || '',
          id: doc.id || 0,
          active: true,
          uploadedAt: new Date().toISOString(),
        })) || []

      setModuleDocument(modifiedData)
      
    } catch (error) {
      console.error('Error fetching module documents:', error)
    }
  }

  const normFile = e => {
    if (!e) return [];
    return e.fileList || [];
  };


  const getBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result.split(',')[1])
      reader.onerror = error => reject(error)
    })
  }

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   validateFields(async (err, values) => {
  //     if (!err) {
  //       try {
  //         const payload = await Promise.all(
  //           moduleDocument.map(async (doc) => {
  //             const file = values[doc.key]?.[0]?.originFileObj;
  //             if (file) {
  //               const fileBase64 = await getBase64(file);

  //               return {
  //                 moduleId: policyId,
  //                 documentMasterId: doc.documentMasterId,
  //                 fileBytes: fileBase64,
  //                 id: doc.id || 0,
  //                 documentName: doc.documentName,
  //                 filePath: doc.filePath || '',
  //                 uploadedAt: new Date().toISOString(),
  //                 active: true,
  //               };
  //             } else {
  //               return null;
  //             }
  //           })
  //         );

  //         const filteredPayload = payload.filter(item => item !== null);
  //         if (filteredPayload.length === 0) {
  //           message.warning('Please upload at least one document.');
  //           return;
  //         }

  //         const urlBase = process.env.REACT_APP_BASE_URL_DOCUMENT;

  //         for (const item of filteredPayload) {
  //           const url = documentId
  //             ? `${urlBase}Document/Update/${documentId}`
  //             : `${urlBase}Document`;

  //           const method = 'POST';

  //           const response = await apiRequest(url, method, item);
  //           if (response.success && response.data?.filePath) {
  //             toast.success(
  //               documentId
  //                 ? 'Document updated successfully!'
  //                 : 'Document uploaded successfully!'
  //             );
  //           } else {
  //             toast.error(response.error || 'Upload failed');
  //           }
  //         }
  //       } catch (error) {
  //         console.error(error);
  //         toast.error('Something went wrong');
  //       }
  //     }
  //   });
  // };

  const handleSubmit = async e => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        try {
          const payload = await Promise.all(
            moduleDocument.map(async doc => {
              const file = values[doc.key]?.[0]?.originFileObj
              if (file) {
                const fileBase64 = await getBase64(file)
                return {
                  moduleId: insurerId,
                  productId: ProductId,
                  documentMasterId: doc.documentMasterId,
                  fileBytes: fileBase64,
                  documentName: doc.documentName,
                  filePath: doc.filePath || '',
                  uploadedAt: new Date().toISOString(),
                  active: true,
                  entityType: 'policy',
                  EntityId: policyId,
                  InsurerId: insurerId,
                  EntityNumber: policynumber,
                }
              } else {
                return null
              }
            }),
          )

          const filteredPayload = payload.filter(item => item !== null)
          if (filteredPayload.length === 0) {
            message.warning('Please upload at least one document.')
            return
          }

          const urlBase = process.env.REACT_APP_BASE_URL_DOCUMENT

          for (const item of filteredPayload) {
            const url = documentId
              ? `${urlBase}/Document/Update/${documentId}`
              : `${urlBase}/Document`

            const method = 'POST'

            const response = await apiRequest(url, method, item)
            if (response.success) {
              toast.success(
                documentId
                  ? 'Document updated successfully!'
                  : 'Document uploaded successfully!',
              );
               if (onSucess) onSucess();
            } else {
              // toast.error(response.error || 'Upload failed for one of the documents');
            }
          }
          const statusCheckUrl = `${urlBase}/Document/Status/${policyId}`
          const statusCheckResponse = await apiRequest(statusCheckUrl, 'GET')
          if (statusCheckResponse.success) {
            const statusData = statusCheckResponse.data?.success
            if (statusData
              // === 'All Required Documents Uploaded'
            ) {
              const statusUpdateUrl = `${process.env.REACT_APP_BASE_URL_MICROSERVICE}/Policy/StatusUpdate/status-update`
              const statusUpdatePayload = {
                id: policyId,
                status: 3,
              }
              const statusUpdateResponse = await apiRequest(statusUpdateUrl, 'POST', statusUpdatePayload,)
              const SendMailToWroker = await apiRequest(process.env.REACT_APP_BASE_URL + `/Policy/SendEmailToBroker/send-email-to-broker/${policyId}`, 'POST')
              if (statusUpdateResponse.success) {
                // toast.success('Document status updated successfully!');
                onSucess()
              } else {
                toast.error('Failed to update document status')
              }
            } else {
              toast.error('Failed to update document status')
            }
          } else {
            // toast.error('Failed to check document status');
          }
        } catch (error) {
          console.error(error)
          toast.error('Something went wrong')
        }
      }
    })
  }
  // const handleSubmit = async e => {
  //   e.preventDefault();
  //   validateFields(async (err, values) => {
  //     if (!err) {
  //       try {
  //         const payload = await Promise.all(
  //           moduleDocument.map(async doc => {
  //             const file = values[doc.key]?.[0]?.originFileObj;
  //             if (file) {
  //               const fileBase64 = await getBase64(file);
  //               return {
  //                 moduleId: insurerId,
  //                 productId: ProductId,
  //                 documentMasterId: doc.documentMasterId,
  //                 fileBytes: fileBase64,
  //                 documentName: doc.documentName,
  //                 filePath: doc.filePath || '',
  //                 uploadedAt: new Date().toISOString(),
  //                 active: true,
  //                 entityType: 'policy',
  //                 EntityId: policyId,
  //                 EntityNumber: policynumber,
  //               };
  //             } else {
  //               return null;
  //             }
  //           })
  //         );

  //         const filteredPayload = payload.filter(item => item !== null);
  //         if (filteredPayload.length === 0) {
  //           message.warning('Please upload at least one document.');
  //           return;
  //         }

  //         // Instead of calling the real APIs, simulate the success flow
  //         for (const item of filteredPayload) {
  //           // Mock upload: just wait a bit and assume success
  //           await new Promise(resolve => setTimeout(resolve, 100));
  //           toast.success(
  //             documentId
  //               ? 'Document updated successfully!'
  //               : 'Document uploaded successfully!'
  //           );
  //         }

  //         // Simulate document status check
  //         await new Promise(resolve => setTimeout(resolve, 100));
  //         const statusData = 'All Required Documents Uploaded';

  //         if (statusData === 'All Required Documents Uploaded') {
  //           // Simulate status update
  //           await new Promise(resolve => setTimeout(resolve, 100));
  //           // Simulate sending email
  //           await new Promise(resolve => setTimeout(resolve, 100));
  //           // Final success
  //           onSucess();
  //         } else {
  //           toast.error('Failed to update document status');
  //         }

  //       } catch (error) {
  //         console.error(error);
  //         toast.error('Something went wrong');
  //       }
  //     }
  //   });
  // };

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            {moduleDocument.map((doc, index) => (
              <Col span={12} key={index}>
                <Form.Item label={doc.documentName}>
                  {getFieldDecorator(doc.key, {
                    valuePropName: 'fileList',
                    getValueFromEvent: e => (e && e.fileList ? e.fileList : []),
                    rules: [
                      { required: doc.required, message: `${doc.documentName} is required` }
                    ]
                  })(
                    <Upload
                      name={doc.key}
                      beforeUpload={() => false}
                      maxCount={1}
                      multiple={false}
                    >
                      <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                  )}
                </Form.Item>

              </Col>
            ))}
          </Row>
          <Button type="primary" className="btn-success" htmlType="submit">
            Submit Documents
          </Button>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(UploadDocument)
